import { render, staticRenderFns } from "./WsRequestAccredCompsForm.vue?vue&type=template&id=3a3e9efe"
import script from "./WsRequestAccredCompsForm.vue?vue&type=script&lang=js"
export * from "./WsRequestAccredCompsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports